/**
 * The idle tournament card (G5) — a SIBLING of the board frame inside
 * `stage/Stage`'s `boardSlot`, absolute like `BoardCountdown`: a dimming scrim
 * over the (disabled, start-position) board, and a centred card on top of it.
 */
import React from 'react';
import {StyleSheet, View} from 'react-native';

import {RADIUS, SPACE} from '../../theme/tokens';
import {useV2Theme} from '../../theme/useV2Theme';
import {Button, Txt} from '../../ui';
import {TournamentIdleModel} from './model';

/** the board reads at roughly 60 % brightness under this */
const SCRIM_OPACITY = 0.4;

export default React.memo(function TournamentIdleView({
  kind,
  title,
  subtitle,
  actionLabel,
  onAction,
}: TournamentIdleModel) {
  const tokens = useV2Theme(s => s.tokens);

  if (kind === 'none') {
    return null;
  }

  return (
    <View
      style={styles.overlay}
      pointerEvents="box-none"
      testID="v2-tournament-idle">
      <View
        style={[
          styles.scrim,
          {backgroundColor: tokens.bg, opacity: SCRIM_OPACITY},
        ]}
        pointerEvents="none"
      />
      <View
        style={[
          styles.card,
          {
            backgroundColor: tokens.surface,
            borderColor: tokens.cardline,
            boxShadow: tokens.sh2,
          } as any,
        ]}>
        <Txt
          variant="cardTitle"
          tone="ink"
          numberOfLines={2}
          style={styles.title}>
          {title}
        </Txt>
        {!!subtitle && (
          <Txt variant="caption" tone="muted" numeric>
            {subtitle}
          </Txt>
        )}
        {!!actionLabel && (
          <Button
            label={actionLabel}
            variant="primary"
            size="md"
            onPress={onAction}
          />
        )}
      </View>
    </View>
  );
});

const styles = StyleSheet.create({
  overlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    alignItems: 'center',
    justifyContent: 'center',
  },
  scrim: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
  card: {
    maxWidth: '80%',
    borderRadius: RADIUS.card,
    borderWidth: 1,
    paddingVertical: SPACE.lg,
    paddingHorizontal: SPACE.xl,
    gap: SPACE.sm,
    alignItems: 'center',
  },
  title: {
    textAlign: 'center',
  },
});
